import { Protocol } from "@/models/Protocol";
import PaginatedResponse from "@/models/PaginatedResponse";

export const ProtocolRequest = (argProtocol) => {
  let protocol = argProtocol.copy();

  if (!protocol.id) {
    delete protocol.id;
  }

  protocol.questionnaire = protocol.questionnaire.id;

  if (protocol.responsible) {
    protocol.responsible = protocol.responsible.id;
  }

  if (protocol.reporter) {
    protocol.reporter = protocol.reporter.id;
  }

  if (protocol.category) {
    protocol.category = protocol.category.id;
  }

  if (protocol.receiver) {
    protocol.receiver = protocol.receiver.id;
  }

  if (protocol.survey) {
    protocol.survey = protocol.survey.id;
  }
  if (protocol.department) {
    protocol.department = protocol.department.id;
  }

  if (protocol.parent) {
    protocol.parent = protocol.parent.id;
  }

  if (protocol.parent_info) {
    protocol.parent_info = protocol.parent_info.id;
  }

  if (protocol.parent_answer) {
    protocol.parent_answer = protocol.parent_answer.id;
  }

  // Avoid sending empty string to backend for date values
  if (protocol.protocol_date === "") {
    protocol.protocol_date = null;
  }

  if (protocol.tags) {
    for (var i = 0; i < protocol.tags.length; i++) {
      protocol.tags[i] = protocol.tags[i].id;
    }
  }

  if (protocol.info_siblings) {
    for (var i = 0; i < protocol.info_siblings.length; i++) {
      protocol.info_siblings[i] = protocol.info_siblings[i].id;
    }
  }

  protocol.answers.forEach((a) => {
    if (!a.id) {
      delete a.id;
    }

    // Objects to ID's
    a.question = a.question.id;

    if (a.value_option) {
      a.value_option = a.value_option.id;
    }

    // Avoid sending empty string to backend for number values
    if (a.value_number === "") {
      a.value_number = null;
    }

    // Avoid sending empty string to backend for date values
    if (a.value_date === "") {
      a.value_date = null;
    }

    a.activities.forEach((ac) => {
      if (!ac.id) {
        delete ac.id;
      }

      if (ac.category) {
        ac.category = ac.category.id;
      }

      if (ac.questionnaire) {
        ac.questionnaire = ac.questionnaire.id;
      }

      if (ac.responsible) {
        ac.responsible = ac.responsible.id;
      }

      if (ac.controller) {
        ac.controller = ac.controller.id;
      }
    });

    if (a.info_siblings) {
      for (var i = 0; i < a.info_siblings.length; i++) {
        a.info_siblings[i] = a.info_siblings[i].id;
      }
    }

  });

  for (var i = 0; i < protocol.visible_to_departments.length; i++) {
    protocol.visible_to_departments[i] = protocol.visible_to_departments[i].id;
  }

  return protocol;
};

export const ProtocolResponse = (protocol) => {
  return new Protocol(protocol);
};

export const ProtocolsResponse = (protocols) => {
  return protocols.map((p) => ProtocolResponse(p));
};

export const PaginatedProtocolsResponse = (data) => {
  let response = new PaginatedResponse(data);
  response.results = response.results.map((i) => ProtocolResponse(i));
  return response;
};
